import { UserPayload } from "../models/SiteModel";

const URLAPI = process.env.REACT_APP_BASE_URL;

export interface ClienteFacturaImpagaDto {
  id: number;
  idlocal: number;
  fechA_OPERACION: string;
  tipO_DE_FACTURA: string;
  factura: string;
  total: string;
  credito: string;
  saldo: string;
  pagado: string;
  deuda: string;
  estado: string;
}

export interface ClienteMovimientoCuentaDto {
  fecha: string;
  hora: string;
  comprobante: string;
  debe: string;
  haber: string;
  saldo: string;
  detalle: string;
}

export interface ClienteCuentaCorrienteDto {
  facturasImpagas: ClienteFacturaImpagaDto[];
  estadoCuenta: ClienteMovimientoCuentaDto[];
  totalDeuda: string;
  totalDebe: string;
  totalHaber: string;
  saldo: string;
  limitesCuentaCorriente?: {
    limiteDeuda: number;
    maximoComprobantesPendientes: number;
    maximoDiasAtraso: number;
    permiteVentas: boolean;
  } | null;
}

export async function fetchGetClientes(user: UserPayload, signal?: AbortSignal) {
  const token = user.token;
  const response = await fetch(
    `${URLAPI}/Cliente/GetClientes`,
    {
      method: "GET",
      signal,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
    }
  );

  const data = await response.json();
  return data;
}

export async function fetchGetMiCuentaCorriente(user: UserPayload, signal?: AbortSignal): Promise<ClienteCuentaCorrienteDto> {
  const response = await fetch(
    `${URLAPI}/Cliente/GetMiCuentaCorriente`,
    {
      method: "GET",
      signal,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + user.token
      },
    }
  );

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.message ?? "No se pudo obtener la cuenta corriente");
  }
  return data;
}

export async function fetchGetCuentaCorrienteCliente(user: UserPayload, idCliente: number, signal?: AbortSignal): Promise<ClienteCuentaCorrienteDto> {
  const response = await fetch(
    `${URLAPI}/Cliente/GetCuentaCorrienteCliente/${idCliente}`,
    {
      method: "GET",
      signal,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + user.token
      },
    }
  );

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.message ?? "No se pudo obtener la cuenta corriente del cliente");
  }
  return data;
}

export async function fetchDescargarCuentaCorrientePdf(user: UserPayload, idCliente: number, cliente: string) {
  const params = new URLSearchParams();
  if (cliente?.trim()) params.set("cliente", cliente.trim());

  const response = await fetch(`${URLAPI}/Cliente/DescargarCuentaCorrientePdf/${idCliente}?${params.toString()}`, {
    method: "GET",
    headers: {
      "Authorization": "Bearer " + user.token,
    },
  });

  if (!response.ok) {
    let message = "No se pudo descargar el PDF de cuenta corriente";
    try {
      const data = await response.json();
      message = data?.message ?? message;
    } catch { }
    throw new Error(message);
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `CuentaCorriente_${idCliente}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
